import { Component, input, output } from '@angular/core';

@Component({
  standalone: true,
  selector: 'lib-button',
  template: `
    <button [class]="type()" [id]="id()" [disabled]="disabled()" (click)="clickButton.emit()">
      @if (leftIcon()) { <span class="btn-icon btn-icon--left"></span> }
      <ng-content />
      @if (rightIcon()) { <span class="btn-icon btn-icon--right"></span> }
    </button>
  `,
  styles: [`
    button {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;

      height: 40px;
      min-width: 120px;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 0.025em;

      border: none;
      border-radius: 20px;
      padding: 9px 25px;

      color: #00095b;
      background-color: transparent;

      transition: 0.3s;
    }

    .btn-icon {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-top: 2px solid currentColor;
      flex-shrink: 0;

      &--right {
        border-right: 2px solid currentColor;
        transform: rotate(45deg);
      }

      &--left {
        border-left: 2px solid currentColor;
        transform: rotate(-45deg);
      }
    }

    .primary {
      color: #fff !important;
      background-color: #00095b !important;

      &:disabled {
        background-color: #8c8c8c !important;
        cursor: not-allowed !important;

        &:hover {
          background-color: #8c8c8c !important;
          transform: initial !important;
        }
      }

      &:hover {
        background-color: #1700f4 !important;
        transform: scale(1.05);
      }
    }

    .secondary {
      background-color: transparent;
      border-radius: 100px;
      border: 1.8px solid var(--brand-primary-ford-blue, #00095B);
      box-shadow: 0 15px 10px 0 rgba(0, 0, 0, 0.15);

      &:hover {
        transform: scale(1.05);
      }

      &:disabled {
        opacity: 0.25 !important;
        cursor: not-allowed !important;

        &:hover {
          opacity: 0.25 !important;
          transform: initial !important;
        }
      }
    }

    .secondary-large {
      width: 230px;
      background-color: transparent;
      border-radius: 100px;
      border: 1.8px solid var(--brand-primary-ford-blue, #00095B);
      box-shadow: 0 15px 10px 0 rgba(0, 0, 0, 0.15);

      &:hover {
        transform: scale(1.05);
      }

      &:disabled {
        opacity: 0.25 !important;
        cursor: not-allowed !important;

        &:hover {
          opacity: 0.25 !important;
          transform: initial !important;
        }
      }
    }

    .text {
      min-width: unset;
      height: unset;
      padding: 0;
      border-radius: 0;
      font-weight: 400;
      color: #00095b;
      background-color: transparent;

      &:hover {
        text-decoration: underline;
      }

      &:disabled {
        opacity: 0.4;
      }
    }

    .text-v2 {
      min-width: unset;
      border-radius: 0;
      font-weight: 400;
      color: #00095b;
      background-color: transparent;

      &:hover {
        text-decoration: underline;
      }

      &:disabled {
        opacity: 0.4;
      }
    }
  `],
})
export class ButtonLibComponent {
  type = input<'primary' | 'secondary' | 'secondary-large' | 'text' | 'text-v2'>('primary');
  id = input<string>('');
  disabled = input<boolean>(false);
  rightIcon = input<boolean>(false);
  leftIcon = input<boolean>(false);
  clickButton = output();
}
